export default {
  simplePlaceSearch: {
    noPlaceFound: 'Nu s-a găsit niciun loc cu conținut imputat',
    unknownSearchPlaceError: 'Eroare de căutare loc necunoscut',
    openSidebarToSeeRouteDetails: 'Deschideți bara laterală pentru a vedea detaliile traseului',
  }
}
